export default __webpack_public_path__ + "static/media/image-54.dc7eee7f.png";